import { datadogRum } from "@datadog/browser-rum";

import publicConfig from "../public-config";

const initializeDatadog = () => {
  // Read env from the shared public config (injected via the __PUBLIC_ENV__
  // JSON tag under Vite). Previously read from window.* globals set by the old
  // Gulp main.mustache template, which is no longer rendered after the Vite cutover.
  const { PS_ENV, DATADOG_RUM_APPLICATION_ID, DATADOG_RUM_CLIENT_TOKEN, RELEASE_TAG } =
    publicConfig;

  // We only want to initialize Datadog RUM in beta and prod environments only
  if (!["beta", "prod"].includes(PS_ENV)) {
    return;
  }

  if (!DATADOG_RUM_APPLICATION_ID || !DATADOG_RUM_CLIENT_TOKEN) {
    return;
  }

  datadogRum.init({
    applicationId: DATADOG_RUM_APPLICATION_ID,
    clientToken: DATADOG_RUM_CLIENT_TOKEN,
    site: "us5.datadoghq.com",
    service: "web-hosting",
    env: PS_ENV,
    version: RELEASE_TAG,
    allowedTracingUrls: [
      {
        match: /^https?:\/\/.*\.peerspace\.com.*/, // Track internal API calls to peerspace.com
        propagatorTypes: ["tracecontext", "datadog"], // W3C traceparent + Datadog headers
      },
      {
        match: /^https?:\/\/.*\.peerspaceapp\.com.*/, // Track internal API calls to peerspaceapp.com
        propagatorTypes: ["tracecontext", "datadog"], // W3C traceparent + Datadog headers
      },
    ],
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    defaultPrivacyLevel: "mask-user-input",
    trackBfcacheViews: true,
    trackUserInteractions: true,
    trackResources: true,
    enablePrivacyForActionName: true,
    silentMultipleInit: true,
    propagateTraceBaggage: true,
  });
};

export { initializeDatadog };
